import Icon from '../components/Icon.vue'

Icon.register({"angle-up":{"width":1152,"height":1792,"paths":[{"d":"M1075 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-up.js
// module id = 310
// module chunks = 0